/*
 * @Description: 购买前校验的文本
 */

// 高龄客户限制规则-1,2,3,4,5,6
const buyverificationHtml = {
    warnHtml: `投资有风险，投资需谨慎。基金不同于银行储蓄等能够提供固定收益预期的金融工具，当您购买基金产品时，既可能按持有份额分享基金投资所产生的收益，也可能承担基金投资所带来的损失。基金管理人承诺以诚实信用、勤勉尽责的原则管理和运用基金资产，但不保证本基金一定盈利，也不保证最低收益。基金管理人提醒您基金投资的“买者自负”原则，在做出投资决策后，基金运营状况与基金净值变化引致的投资风险，由您自行负担。基金管理人、基金托管人、基金销售机构及相关机构不对基金投资收益做出任何承诺或保证。`,
    forbidHtml: `尊敬的客户，本产品可能导致超出您自身风险承受能力的损失和不利后果，为了保护您的权益，无法继续为您提供该购买服务，敬请谅解。`
};
export default buyverificationHtml;
